var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c("h3", [
        _vm._v("RL 4.1 Kompilasi Penyakit/Morbiditas Pasien Rawat Inap"),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("DataTable", {
        attrs: {
          "table-id": "table-pasien",
          title: "Kompilasi Penyakit/Morbiditas Pasien Rawat Inap",
          "filter-configs": _vm.filterConfigs,
          "table-options": _vm.tableOptions,
          "show-filter": true,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-end mt-3" }, [
        _c("table", { staticClass: "table table-bordered w-auto" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v(_vm._s(_vm.formatNumber(_vm.grandTotal)))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.persentaseTotal) + "%")]),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Total Keseluruhan")]),
        _vm._v(" "),
        _c("th", [_vm._v("Persentase")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }